import "./template-parts/mobile-menu.js";
import "./block-reveal.js";

document.addEventListener("DOMContentLoaded", function () {});
